import React from 'react';
import { clsx } from 'clsx';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: 'none' | 'sm' | 'md' | 'lg';
  bordered?: boolean;
  hoverable?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  title,
  actions,
  className,
  padding = 'md',
  shadow = 'md',
  bordered = true,
  hoverable = false
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  const shadowClasses = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg'
  };

  const baseClasses = 'bg-white rounded-lg transition-shadow';
  const borderClasses = bordered ? 'border border-gray-200' : '';
  const hoverClasses = hoverable ? 'hover:shadow-lg cursor-pointer' : '';

  return (
    <div
      className={clsx(
        baseClasses,
        borderClasses,
        shadowClasses[shadow],
        hoverClasses,
        className
      )}
    >
      {title && (
        <div className={clsx(
          'border-b border-gray-200 flex items-center justify-between',
          padding === 'none' ? 'px-6 py-4' : paddingClasses[padding]
        )}>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          {actions && <div className="flex space-x-2">{actions}</div>}
        </div>
      )}
      
      <div className={clsx(
        paddingClasses[padding],
        title && 'pt-0'
      )}>
        {children}
      </div>
    </div>
  );
};

export default Card; 